import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Location } from '../models/location.model';

@Injectable()
export class LocationService {
  private locationsRef: AngularFireList<Location> = null;
  private path = 'locations/';

  constructor(private db: AngularFireDatabase) {
    this.locationsRef = db.list(this.path);
  }

  getAll(): Observable<Location[]> {
    return this.locationsRef.snapshotChanges()
    .pipe(
      map(changes =>
        changes.map(changes => ({
          name: changes.payload.key, ...changes.payload.val()
        }))
      )
    );
  }

  add(key: string): Promise<void> {
    return this.db.object(this.path + key).set({
      weatherDataItems: ''
    });
  }

  update(key: string, data: {}): Promise<void> {
    return this.locationsRef.update(key, data);
  }

  delete(key: string): Promise<void> {
    return this.locationsRef.remove(key);
  }
}
